<template>
  <div>
    <Breadcrumb :breadcrumbList="breadcrumbList" />
    <div class="content-header px-0">
      <h1>Adicionar Configuração</h1>
    </div>
    <div class="row mt-3">
      <TwInput col_lg="4" label="Área">
        <div class="input-group mb-3">
          <input
            id="newarea"
            v-model="novaarea"
            type="text"
            maxlength="50"
            class="form-control"
            placeholder="Adicionar Nova Área"
            aria-label="Adicionar Nova Área"
            aria-describedby="basic-addon2"
          />
          <div class="input-group-append">
            <button
              class="btn btn-primary"
              id="basic-addon2"
              type="button"
              @click="addArea"
              :disabled="load"
            >
              <i v-if="load" class="fas fa-sync-alt fa-spin"></i>
              Adicionar
            </button>
          </div>

          <b-table
            responsive="sm"
            striped
            :busy="load"
            borderless
            hover
            :fields="fields_area"
            :items="setores"
            class="mt-3 rounded"
          >
            <template v-slot:table-busy>
              <div class="text-center my-2">
                <strong>
                  <i class="fas fa-sync-alt fa-spin"></i>
                </strong>
              </div>
            </template>

            <template v-slot:table-colgroup>
              <col
                v-for="field in fields_area"
                :key="field.key"
                :style="{ width: field.key === 'actions' ? '100px' : '550px' }"
              />
            </template>
            <template v-slot:cell(area)="data">
            <span>
              {{spliceField(data.item.area, 29)}}
          </span>
          </template>
            <template v-slot:cell(actions)="data">
              <a
                id="deletearea"
                @click="area = data.item.area"
                href="#"
                class="ml-4"
                data-toggle="modal"
                data-target="#modalDeleteArea"
                title="Excluir"
              >
                <i class="far fa-trash-alt"></i>
              </a>
            </template>
          </b-table>
        </div>
        <Modal
          id="modalDeleteArea"
          title="Excluir Área"
          v-bind:msg="'Tem certeza que deseja excluir?'"
          button="Excluir"
          :method="deleteArea"
        />
      </TwInput>
      <TwInput col_lg="4" label="Departamento">
        <div class="input-group mb-3">
          <input
            id="newdepartment"
            v-model="novodepartamento"
            type="text"
            maxlength="50"
            class="form-control"
            placeholder="Adicionar Novo Departamento"
            aria-label="Adicionar Novo Departamento"
            aria-describedby="basic-addon3"
          />
          <div class="input-group-append">
            <button
              class="btn btn-primary"
              id="basic-addon3"
              type="button"
              @click="addDepartamento"
              :disabled="load"
            >
              <i v-if="load" class="fas fa-sync-alt fa-spin"></i>
              Adicionar
            </button>
          </div>
        </div>
        <b-table
          responsive="sm"
          striped
          :busy="load"
          borderless
          hover
          :fields="fields_departamento"
          :items="departamentos"
          class="mt-3 rounded"
        >
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <strong>
                <i class="fas fa-sync-alt fa-spin"></i>
              </strong>
            </div>
          </template>

          <template v-slot:table-colgroup>
            <col
              v-for="field in fields_departamento"
              :key="field.key"
              :style="{ width: field.key === 'actions' ? '100px' : '550px' }"
            />
          </template>
          <template v-slot:cell(department)="data">
            <span>
              {{spliceField(data.item.department, 29)}}
          </span>
          </template>
          <template v-slot:cell(actions)="data">
            <a
              id="deletedepartamento"
              @click="departamento = data.item.department"
              href="#"
              class="ml-4"
              data-toggle="modal"
              data-target="#modalDeleteDepartamento"
              title="Excluir"
            >
              <i class="far fa-trash-alt"></i>
            </a>
          </template>
        </b-table>

        <Modal
          id="modalDeleteDepartamento"
          title="Excluir Departamento"
          v-bind:msg="'Tem certeza que deseja excluir?'"
          button="Excluir"
          :method="deleteDepartamento"
        />
      </TwInput>
      <TwInput col_lg="4" label="Cargo">
        <div class="input-group mb-3">
          <input
            id="newposition"
            v-model="novocargo"
            type="text"
            maxlength="50"
            class="form-control"
            placeholder="Adicionar Novo Cargo"
            aria-label="Adicionar Novo Cargo"
            aria-describedby="basic-addon4"
          />
          <div class="input-group-append">
            <button
              class="btn btn-primary"
              id="basic-addon4"
              type="button"
              @click="addCargo"
              :disabled="load"
            >
              <i v-if="load" class="fas fa-sync-alt fa-spin"></i>
              Adicionar
            </button>
          </div>
        </div>
        <b-table
          responsive="sm"
          striped
          :busy="load"
          borderless
          hover
          :fields="fields_cargos"
          :items="cargos"
          class="mt-3 rounded"
        >
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <strong>
                <i class="fas fa-sync-alt fa-spin"></i>
              </strong>
            </div>
          </template>

          <template v-slot:table-colgroup>
            <col
              v-for="field in fields_cargos"
              :key="field.key"
              :style="{ width: field.key === 'actions' ? '100px' : '550px' }"
            />
          </template>
          <template v-slot:cell(position)="data">
            <span>
              {{spliceField(data.item.position, 29)}}
          </span>
          </template>
          <template v-slot:cell(actions)="data">
            <a
              id="deletecargo"
              @click="cargo = data.item.position"
              href="#"
              class="ml-4"
              data-toggle="modal"
              data-target="#modalDeleteCargo"
              title="Excluir"
            >
              <i class="far fa-trash-alt"></i>
            </a>
          </template>
        </b-table>

        <Modal
          id="modalDeleteCargo"
          title="Excluir Cargo"
          v-bind:msg="'Tem certeza que deseja excluir?'"
          button="Excluir"
          :method="deleteCargo"
        />
      </TwInput>
    </div>
  </div>
</template>

<script>
import Modal from "../../components/Modal.vue";
import Breadcrumb from "../../components/Breadcrumb.vue";
import TwInput from "@/components/TwInput.vue";
import { spliceField } from "../../utils/format-fields";

export default {
  name: "CustomerConfig",
  data() {
    return {
      breadcrumbList: [],
      novaarea: null,
      area: null,
      fields_area: [
        { key: "area", sortable: true, label: "Área" },
        { key: "actions", label: "Excluir", sortable: false, class: "actions" },
      ],
      departamento: null,
      novodepartamento: null,
      fields_departamento: [
        { key: "department", sortable: true, label: "Setor" },
        { key: "actions", label: "Excluir", sortable: false, class: "actions" },
      ],
      cargo: null,
      novocargo: null,
      fields_cargos: [
        { key: "position", sortable: true, label: "Cargo" },
        { key: "actions", label: "Excluir", sortable: false, class: "actions" },
      ],
    };
  },
  watch: {
    customer() {
      if (this.customer) {
        this.updateList();
      }
    },
    $route() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    },
  },
  methods: {
    spliceField,
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
      if (this.customer) {
        this.breadcrumbList[1].label = `Editar cliente ${this.customer.company_name}`;
      }
    },
    deleteArea() {
      event.preventDefault();
      this.$store.dispatch("employee/setores/deleteEmployeeAreas", {
        area: this.area,
        customer_id: parseInt(this.$route.params.customerId),
      });
    },
    addArea() {
      if (!this.novaarea?.trim())
        window.frontMsg("FRNT_EMPTY_WARNING", { field: "Área" });
      else {
        this.$store.dispatch("employee/setores/saveEmployeeArea", {
          area: this.novaarea.trim(),
          customer_id: parseInt(this.$route.params.customerId),
        });
        this.novaarea = null;
      }
    },
    deleteDepartamento() {
      event.preventDefault();
      this.$store.dispatch(
        "employee/departamentos/deleteEmployeeDepartamentos",
        {
          departamento: this.departamento,
          customer_id: parseInt(this.$route.params.customerId),
        }
      );
    },
    addDepartamento() {
      if (!this.novodepartamento?.trim())
        window.frontMsg("FRNT_EMPTY_WARNING", { field: "Setor" });
      else {
        this.$store.dispatch(
          "employee/departamentos/saveEmployeeDepartamentos",
          {
            departamento: this.novodepartamento.trim(),
            customer_id: parseInt(this.$route.params.customerId),
          }
        );
        this.novodepartamento = null;
      }
    },
    deleteCargo() {
      event.preventDefault();
      this.$store.dispatch("employee/cargos/deleteEmployeeCargos", {
        cargo: this.cargo,
        customer_id: parseInt(this.$route.params.customerId),
      });
    },
    addCargo() {
      if (!this.novocargo?.trim())
        window.frontMsg("FRNT_EMPTY_WARNING", { field: "Cargo" });
      else {
        this.$store.dispatch("employee/cargos/saveEmployeeCargos", {
          cargo: this.novocargo.trim(),
          customer_id: parseInt(this.$route.params.customerId),
        });
        this.novocargo = null;
      }
    },
  },
  mounted() {
    this.$store.dispatch("employee/setores/getEmployeeAreas", {
      customer_id: this.$route.params.customerId,
    });
    this.$store.dispatch("employee/departamentos/getEmployeeDepartamentos", {
      customer_id: this.$route.params.customerId,
    });
    this.$store.dispatch("employee/cargos/getEmployeeCargos", {
      customer_id: this.$route.params.customerId,
    });

    if (this.$route.params.customerId) {
      this.$store.dispatch("customer/getCustomer", {
        customerId: this.$route.params.customerId,
      });
    } else {
      window.frontMsg("FRNT_MISSING_WARNING", { frontelement: "do Cliente" });
      this.$router.push("/");
    }
    this.updateList();
  },
  computed: {
    load() {
      return this.$store.getters["load"];
    },
    setores() {
      return this.$store.getters["employee/setores/areas"];
    },
    departamentos() {
      return this.$store.getters["employee/departamentos/departamentos"];
    },
    cargos() {
      return this.$store.getters["employee/cargos/cargos"];
    },
    rows() {
      return this.users.length;
    },
    customer() {
      return this.$store.getters["customer/customer"];
    },
  },
  components: {
    Modal,
    Breadcrumb,
    TwInput,
  },
};
</script>

<style lang="scss" scoped>
.b-table {
  text-transform: uppercase;
}
</style>
